/* MARCA | 08 Apr 2026 | Ghost product add-to-cart functionality for cart drawer */
(function () {
  'use strict';

  var addInProgress = false;

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.cart-ghost-product__add-btn');
    if (!button || button.disabled || addInProgress) return;

    e.preventDefault();
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    addInProgress = true;

    var textEl = button.querySelector('.cart-ghost-product__btn-text');
    var originalText = textEl ? textEl.textContent : 'Add';
    button.disabled = true;
    if (textEl) textEl.textContent = 'Adding...';

    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        return fetch(rootPath + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ sections: sectionsToBundle }),
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ghost-product',
            cart: cart,
          });
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (err) {
        console.error('[GhostProduct] Add to cart failed:', err);
        if (textEl) textEl.textContent = originalText;
        button.disabled = false;
      })
      .finally(function () {
        addInProgress = false;
      });
  });
})();
